module.exports = "/_next/static/images/Graph_01_exhange of goods@2x-66a8b1224a7153fa600b19ef1545f321.png";